import {
  HttpEvent,
  HttpHandler,
  HttpHandlerFn,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { convertIsoStringToDate } from '@plugins/shared/utils/dateUtils';

import { JsonDateInjectConfig } from './json-date.config';

@Injectable()
export class JsonDateInterceptor implements HttpInterceptor {
  private readonly config = inject(JsonDateInjectConfig);

  intercept<T>(
    req: HttpRequest<T>,
    next: HttpHandler,
  ): Observable<HttpEvent<T>> {
    if (!this.shouldIntercept(req)) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      map((val: HttpEvent<T>) => {
        if (val instanceof HttpResponse) {
          convertIsoStringToDate(val.body);
        }
        return val;
      }),
    );
  }

  protected shouldIntercept<T>(req: HttpRequest<T>): boolean {
    for (const path of this.config.paths) {
      if (req.url.startsWith(path)) {
        return true;
      }
    }
    return false;
  }
}

type ObservableHttpEvent<T> = Observable<HttpEvent<T>>;

export const jsonDateInterceptorFn = <T>(
  req: HttpRequest<T>,
  next: HttpHandlerFn,
): ObservableHttpEvent<T> => {
  const config = inject(JsonDateInjectConfig);

  let shouldIntercept = false;
  for (const path of config.paths) {
    if (req.url.startsWith(path)) {
      shouldIntercept = true;
      break;
    }
  }

  if (!shouldIntercept) return next(req) as ObservableHttpEvent<T>;

  return next(req).pipe(
    filter((val): val is HttpResponse<T> => !!val),
    map((val) => {
      if (val instanceof HttpResponse) {
        convertIsoStringToDate(val.body);
      }
      return val;
    }),
  );
};
